import { render, staticRenderFns } from "./CollectionGroupLayer.vue?vue&type=template&id=47eae7a8&scoped=true&lang=pug"
import script from "./CollectionGroupLayer.vue?vue&type=script&lang=js"
export * from "./CollectionGroupLayer.vue?vue&type=script&lang=js"
import style0 from "./CollectionGroupLayer.vue?vue&type=style&index=0&id=47eae7a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47eae7a8",
  null
  
)

export default component.exports